<template>
  <div class="exhibitorsDetailBox">
    <div class="head max-width">
      <!-- 头部banner-->
      <div class="head-img">
        <img :src="headImgUrl" />
      </div>
      <!-- 导航栏-->
      <div class="head-nav">
        <div class="sub-nav" v-for="(item,index) in navList" :key="index" @click="goLink(item.link)">{{item.title}}</div>
      </div>
    </div>

    <!-- 展厅背景图-->
    <div class="bg">
      <div class="bg-center">
        <h3>线上展厅</h3>
      </div>
      <div class="bg-btm"></div>
    </div>

    <!-- 地图指引-->
    <div class="map-menu max-width">
      <div class="map-menu-box">
        <div class="map-menu-left">
          <div class="map-icon">
            <img src="../../static/image/map-icon.png"/>
          </div>
          <div class="map-info">
            您在这里：
            <span class="map-nav">{{mapInfo.nav}}</span>
            <span class="map-line">/</span>
            <span class="map-title">{{mapInfo.title}}</span>
          </div>
        </div>
        <!-- <div class="map-menu-right">{{mapInfo.msg}}</div> -->
      </div>
    </div>

    <div class="content max-width">
      <!-- 搜索-->
      <div class="cate-search">
        <div class="cate-search-title">所有分类</div>
        <div class="cate-search-input">
          <div class="search-input">
            <input v-model="keyword"  type="text" placeholder="请输入参展商名称" />
          </div>
          <div class="search-icon" @click="goSearch()">
            <img src="../../static/image/search-icon.png" />
          </div>
        </div>
      </div>

      <div class="content-box">
        <div class="content-left">
          <ul class="content-left-ul cate-list">
            <li class="back-home" @click="toUrl('/home')">返回上一级</li>
            <li class="company-title">企业/机构信息</li>
            <div class="company-info">
              <div class="compney-name">{{exhibitorsInfo.name}}</div>
              <div class="company-cate">展区：{{exhibitorsInfo.category_pid_name}}</div>
              <div class="company-code">展位：{{exhibitorsInfo.category_name}}</div>
              <div class="company-btn" @click="getPhone(exhibitorsInfo.phone)">预约</div>
            </div>
            <div class="hot-box">
              <div class="hot-box-top">
                <div class="hot-box-title">热门展商</div>
                <div class="hot-box-more" @click="toUrl('/exhibitorsList')">更多</div>
              </div>
              <div class="hot-swiper">
                <swiper :options="swiperOption" v-if="hotCom.length > 0">
                  <swiper-slide v-for="(item, index) in hotCom" :key="index">
                    <ul class="hot-swiper-ul">
                      <li class="hot-swiper-li" v-for="(itemNew,indexNew) in item.list" :key="indexNew" @click="goExhibitors('exhibitorsDetail',itemNew.id)">
                        <div class="exhibitorsDetail-pro-cover">
                          <img :src="itemNew.images" />
                        </div>
                        <div class="exhibitorsDetail-pro-num">{{itemNew.num}}</div>
                        <div class="exhibitorsDetail-pro-name">{{itemNew.name}}</div>
                      </li>
                    </ul>
                  </swiper-slide>
                  <div class="swiper-pagination paginationBanner" slot="pagination"></div>
                </swiper>
              </div>
            </div>
          </ul>
        </div>
        <div class="content-right">
          <div class="exhibitorsInfo-title">{{exhibitorsInfo.name}}</div>
          <div class="exhibitorsInfo-detail">
            <div class="detail-title">
              <div class="detail-title-left">企业详情</div>
              <div class="detail-title-line"></div>
            </div>
            <div class="detail-info" v-html="exhibitorsInfo.content">{{exhibitorsInfo.content}}</div>
          </div>
          <div class="exhibitorsInfo-pro">
            <div class="detail-title">
              <div class="detail-title-left">参展商品</div>
              <div class="detail-title-line"></div>
            </div>
            <div class="pro-list">
              <div class="sub-list" v-for="(item,index) in exhibitorsInfo.goods_list" :key="index">
                <div class="list-pro-cover" @click="goPro('exhibitsDetail',item.goods_id)">
                  <img :src="item.images" />
                </div>
                <div class="list-pro-name" @click="goPro('exhibitsDetail',item.goods_id)">{{item.goods_name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部-->
    <div class="footer">
      <div class="footer-box max-width">
        <div class="footer-left">
          <div class="footer-company">{{footer.companyInfo.name}}</div>
          <div class="footer-tip">{{footer.companyInfo.tip}}</div>
        </div>
        <div class="footer-center">
          <img :src="footer.codeUrl" />
        </div>
        <div class="footer-right">
          <div class="footer-phone">
            <span class="footer-title">{{footer.phone}}</span>
            <img class="footer-icon" src="../../static/image/footer-phone-icon.png" />
          </div>
          <div class="footer-mobile">
            <span class="footer-title">{{footer.mobile}}</span>
            <img class="footer-icon" src="../../static/image/footer-mobile-icon.png" />
          </div>
          <div class="footer-email">
            <span class="footer-title">{{footer.email}}</span>
            <img class="footer-icon" src="../../static/image/footer-email-icon.png" />
          </div>
        </div>
      </div>
    </div>

    <div class="showBox" v-if="showBox" @click="closeDialog">
      <div class="dialog">
        <div class="dialog-content">联系电话：<span v-if="exhibitorsInfo.phone">{{exhibitorsInfo.phone}}</span><span v-else>暂无联系方式</span></div>
        <div class="dialog-btn" @click="closeDialog">关闭</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import '../assets/css/swiper.min.css';
  export default {
    name: 'exhibitorsDetail',
    components: {
      swiper,
      swiperSlide
    },
    data () {
      return {
        showBox: false,
        phone: '暂无联系方式',
       headImgUrl: 'https://www.ywwjz.com/assets/img/head_logo.png',
        navList: [{
          'title': '首页',
          'link': 'https://www.ywwjz.com'
        }, {
          'title': '展会信息',
          'link': 'https://www.ywwjz.com/p/aboutus'
        }, {
          'title': '线上展厅',
          'link': 'https://www.ywwjz.com/wszt.html#/home'
        }, {
          'title': '展会新闻',
          'link': 'https://www.ywwjz.com/c/zhxw.html'
        }, {
          'title': '联系我们',
          'link': 'https://www.ywwjz.com/d/message.html'
        }],
        mapInfo: {
          nav: '首页',
          title: '网上展厅',
          msg: '温馨提示：以下展品展示，仅供参考'
        },
        exhibitorsInfo: {},
        hotCom: [],
        swiperOption: {
          pagination: {
            el: ".paginationBanner",
            clickable: true
          },
          autoplay: {
            disableOnInteraction: false,
            delay: 5000
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true
        },
        footer: {
          companyInfo: {
            name: '中国义乌文具礼品展览会',
            tip: 'CHINA YIWU STATIONERY&GIFT EXHIBITION'
          },
          codeUrl: 'https://www.ywwjz.com/uploads/20200512/4dce8c3bbb75345f7dea9c5ba5c81f60.png',
          phone: '0579—85163311',
          mobile: '18867567324',
          email: '964959387@qq.com'
        },
        keyword:'',
      }
    },
    mounted () {
      var id = this.$route.query.id;
      this.init(id);
    },
    methods: {
      init(id){
        const that = this;
        var api = 'https://www.ywwjz.com/addons/litestore/api.index/get_exhibitors';
        that.$http.get(api, {params: {exhibitors_id: id}}).then((res) => {
            // 响应成功回调
            if(res.body.code == 1){
              that.exhibitorsInfo = res.data.data.exhibitors;
              that.hotCom = res.data.data.hotExhibitors;
            }else{
              console.log('获取数据失败')
            }
        }, (error) => {
            // 响应错误回调
            console.log(error);
        });
      },
      toUrl(url){
        this.$router.push({ path: url })
      },
      getPhone(phone){
        this.showBox = true;
      },
      closeDialog(){
        this.showBox = false;
      },
      //展商详情
      goExhibitors(url,id){
        this.$router.push({name: url, query: { id: id }});
        this.init(id);
      },
      goPro(url,id){
        this.$router.push({name: url, query: { id: id }});
      },
      //跳转地址
      goLink(url){
        window.location.href=url
      },
      //搜索跳转
      goSearch(){
        var url = 'exhibitorsList';
        this.$router.push({name: url, query: { type:2,title:this.keyword}})
      },
    }
  }
</script>

<style>
  body {
    margin: 0;
    font-family: arial, 'Microsoft YaHei', helvetica, sans-serif;
  }
  .max-width {
    max-width: 1200px;
    margin: 0 auto;
  }
  .head-img img {
    width: 100%;
    display: block;
  }
  .head-nav {
    overflow: hidden;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #046575;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: bolder;
    letter-spacing: 5px;
  }
  .sub-nav {
    width: 20%;
    float: left;
    color: white;
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0px;
  }
  .sub-nav:hover {
    background: #13b5b1;
    cursor: pointer;
  }
  .bg {
    background: url(https://www.ciie.org/resource/static/zbh/default/assets-2019/img/innerbannerbg.png) center;
    background-size: cover;
    min-height: 240px;
    overflow: hidden;
    position: relative;
    width: 100%;
  }
  .bg-center {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
    color: #FFFFFF;
    font-size: 30px;
    font-weight: bolder;
  }
  .bg-center h3 {
    margin-top: 80px;
  }
  .bg-btm {
    background: url(https://www.ciie.org/resource/static/zbh/default/assets-2019/img/svg326.png) 0 top;
    background-size: 100%;
    position: absolute;
    width: 100%;
    bottom: 0;
    z-index: 0;
    height: 48px;
  }
  .map-menu {
    height: 60px;
    line-height: 60px;
    padding: 0 15px;
    color: #666666;
  }
  .map-menu-box {
    overflow: hidden;
    border-bottom: 2px solid rgba(0, 0, 0, 0.07);
  }
  .map-menu-left {
    float: left;
    overflow: hidden;
  }
  .map-icon {
    float: left;
    width: 20px;
    height: 20px;
    position: relative;
    top: 20px;
    margin-right: 20px;
  }
  .map-icon img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .map-info {
    float: left;
  }
  .map-nav {
    color: #66aeff;
    cursor: pointer;
  }
  .map-line {
    margin: 0 5px;
    color: #cccccc;
  }
  .map-menu-right {
    float: right;
    color: #ff5503;
  }
  .content {
    padding-top: 30px;
    min-height: 600px;
  }
  .cate-search {
    overflow: hidden;
    background: #046575;
    height: 36px;
    line-height: 36px;
    padding: 10px 0;
  }
  .cate-search-title {
    width: 16%;
    float: left;
    color: #FFFFFF;
    cursor: pointer;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
  }
  .cate-search-select {
    width: 16%;
    float: left;
    cursor: pointer;
  }
  .search-select {
    width: 100%;
    height: 36px;
    border: none;
    border-radius: 10px;
    padding: 0 10px;
    color: #666666;
    cursor: pointer;
  }
  .cate-search-input {
    width: calc(30% - 15px);
    padding-right: 15px;
    float: right;
    overflow: hidden;
  }
  .search-input {
    width: calc(100% - 36px);
    float: left;
  }
  .search-input input {
    width: 100%;
    height: 36px;
    line-height: 36px;
    border: none;
    padding: 0 0 0 10px;
    margin: 0;
    display: block;
  }
  .search-icon {
    float: left;
    width: 16px;
    height: 16px;
    background: #d9dee2;
    padding: 10px;
    cursor: pointer;
  }
  .search-icon:hover {
    background: #FFC107;
  }
  .search-icon img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .content-box {
    overflow: hidden;
    margin-top: 30px;
  }
  .content-left {
    width: calc(30% - 25px);
    padding-right: 25px;
    float: left;
  }
  .content-left-ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  .back-home {
    height: 52px;
    line-height: 52px;
    background: #046575;
    color: #FFFFFF;
    font-size: 18px;
    text-align: center;
    position: relative;
    cursor: pointer;
    border-bottom: 1px solid #FFFFFF;
  }
  .back-home::before {
    content: '';
    width: 10px;
    height: 10px;
    border-top: 4px solid #FFFFFF;
    border-right: 4px solid #FFFFFF;
    transform: rotate(-135deg);
    position: absolute;
    top: 50%;
    left: 20px;
    margin-top: -5px;
  }
  .company-title {
    height: 48px;
    line-height: 48px;
    background: #046575;
    color: #FFFFFF;
    font-size: 16px;
    text-align: center;
  }
  .content-right {
    width: 70%;
    float: right;
  }
  .company-info {
    padding: 30px 20px;
    background-color: #f9f9f9;
  }
  .compney-name {
    font-size: 18px;
    font-weight: 900;
    color: #21242b;
    line-height: 1.4;
    margin-bottom: 10px;
  }
  .company-cate,.company-code {
    line-height: 1.8;
    color: #666e70;
    margin-bottom: 6px;
  }
  .company-btn {
    width: 70px;
    height: 20px;
    line-height: 20px;
    padding: 4px 0;
    background-color: #ff5503;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: bold;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    margin: 15px auto 0 auto;
  }
  .hot-box-top {
    height: 28px;
    overflow: hidden;
    padding: 10px 20px;
    background: #046575;
    color: #FFFFFF;
  }
  .hot-box-title {
    float: left;
    height: 28px;
    line-height: 28px;
    font-size: 16px;
  }
  .hot-box-more {
    float: right;
    border: 1px solid rgba(255, 255, 255, 0.52);
    padding: 0 10px;
    border-radius: 4px;
    height: 26px;
    line-height: 26px;
    color: #ffd522;
    font-size: 16px;
    cursor: pointer;
  }
  .hot-swiper img {
    width: 100%;
  }
  .hot-swiper-ul{
    list-style-type:none;
    padding: 0;
    margin: 0;
  }
  .hot-swiper-li {
    background: #eee;
    margin-bottom: 2px;
    overflow: hidden;
    padding: 5px;
    cursor: pointer;
  }
  .hot-swiper-li:hover {
    border-left: 3px solid #046575;
  }
  .hot-swiper-li:last-child {
    margin-bottom: 0;
  }
  .exhibitorsDetail-pro-cover {
    float: left;
    width: 60px;
    height: 60px;
    padding: 5px;
    border-radius: 50%;
  }
  .exhibitorsDetail-pro-cover img {
    width: 100%;
    height: 100%;
    display: block;
    border: 2px solid #FFFFFF;
    border-radius: 50%;
  }
  .exhibitorsDetail-pro-num {
    float: left;
    width: 40px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-size: 46px;
    font-weight: 700;
    padding: 0 5px;
  }
  .hot-swiper-li:nth-child(1) .exhibitorsDetail-pro-num{
    color: #e74240;
  }
  .hot-swiper-li:nth-child(2) .exhibitorsDetail-pro-num{
    color: #ed713d;
  }
  .hot-swiper-li:nth-child(3) .exhibitorsDetail-pro-num{
    color: #feb185;
  }
  .exhibitorsDetail-pro-name {
    float: left;
    width: calc(100% - 122px);
    height: 70px;
    line-height: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .exhibitorsInfo-title {
    font-size: 30px;
    font-weight: 900;
    line-height: 1.4;
    color: #21242b;
    text-align: center;
    margin-bottom: 20px;
  }
  .exhibitorsInfo-detail,.exhibitorsInfo-pro {
    margin-bottom: 20px;
    padding-left: 20px;
  }
  .detail-title {
    overflow: hidden;
    margin-bottom: 15px;
  }
  .detail-title-left {
    width: 100px;
    height: 32px;
    line-height: 32px;
    float: left;
    font-size: 24px;
    font-weight: bold;
    overflow: hidden;
    color: #046575;
    padding-right: 25px;
  }
  .detail-title-line {
    float: left;
    width: calc(100% - 225px);
    height: 16px;
    background: #e9e9e9;
    position: relative;
    top: 8px;
  }
  .detail-info {
    text-indent: 2em;
    color: #777;
    letter-spacing: 1px;
    font-size: 14px;
    line-height: 1.5;
    text-align: justify;
  }
  .pro-list {
    overflow: hidden;
  }
  .sub-list {
    float: left;
    padding: 0 10px;
    width: calc((100% - 80px) / 4);
    margin-bottom: 20px;
  }
  .list-pro-cover {
    height: 150px;
    overflow: hidden;
    border: 1px solid #dddddd;
    cursor: pointer;
  }
  .list-pro-cover img {
    width: 100%;
    display: block;
  }
  .list-pro-name {
    padding: 0 10px;
    width: calc(100% - 20px);
    height: 40px;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
    overflow: hidden;
    color: #4a4a4a;
    margin-top: 10px;
    cursor: pointer;
  }
  .list-pro-name:hover {
    color: #046575;
  }
  .footer {
    margin-top: 50px;
    background: rgba(73,73,73,1);
    color: #FFFFFF;
  }
  .footer-box {
    overflow: hidden;
    padding: 30px 0;
  }
  .footer-left {
    float: left;
    width: 30%;
    height: 100px;
  }
  .footer-company {
    font-size: 30px;
    margin: 20px 0 5px 0;
    font-weight: bold;
  }
  .footer-tip {
    font-size: 15px;
  }
  .footer-center {
    float: left;
    width: 40%;
    height: 100px;
  }
  .footer-center img {
    width: 100px;
    height: 100px;
    display: block;
    margin: 0 auto;
  }
  .footer-right {
    float: right;
    width: 30%;
    height: 100px;
    text-align: right;
    font-size: 15px;
  }
  .footer-phone {
    overflow: hidden;
    margin-top: 5px;
  }
  .footer-mobile {
    overflow: hidden;
  }
  .footer-email {
    overflow: hidden;
  }
  .footer-icon {
    width: 30px;
    height: 30px;
    float: right;
  }
  .footer-title {
    float: right;
    height: 30px;
    line-height: 30px;
  }
  .showBox {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.7);
    z-index: 99;
  }
  .dialog {
    position: absolute;
    width: 400px;
    height: 90px;
    background: #FFFFFF;
    top: calc(50% - 75px);
    left: calc(50% - 200px);
    padding: 30px 0;
  }
  .dialog-content {
    text-align: center;
    margin-bottom: 40px;
    border-radius: 15px;
  }
  .dialog-btn {
    width: 70px;
    height: 20px;
    line-height: 20px;
    padding: 4px 0;
    background-color: #ff5503;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: bold;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    margin: 15px auto 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/exhibitorsDetail.vue